import React from "react";

import styles from "../NotesPage.module.scss";
import moment from 'moment';
import { patchNotesData, patchNotesTitleData } from "service/NotesService";

const ShowItems = ({ id, title, body, createdAt, action }) => {
  const formatDate = (dateString) => { 
    const date = moment(dateString, 'DD.MM.YYYY HH:mm');
    const today = moment();
  
    if (date.isSame(today, 'day')) {
      return date.format('Сегодня');
     }
     else if (date.isBefore(today, 'day')) {
      return date.format('Создан  DD MMMM YYYY');
    }
    else if(date.isSame(today, 'year')){
      return date.format('Создан DD MMMM')
     } 
    else {
      return date.format('Создан DD MMMM YYYY');
    }
};

const handleChangeNoteData = async (e, id) => {
  const { target } = e;
  const { value } =  target;
  await patchNotesData(id, value);
  action((notes) =>
    notes.map((note)  => {
      if (note.id === id) {
        return { ...note, body:value };
      }
      return note;
    }));
  }
  // const handleChangeTitleData = async (e, id) => {
  //   const { target } = e;
  //   const { value } =  target;
  //   await patchNotesTitleData(id, value);
  //   }
    
  
  

  return (
    <div className={styles["note-item__content"]}>
      {/* <h3 className={styles["note-item__title"]}>{title}</h3> */}
      {/* <input type="text" className={styles["note-item__title"]}
        onChange={(e) => handleChangeTitleData(e, id)}
        defaultValue={title}
      /> */}
      <p className={styles["note-item__date"]}>{formatDate(createdAt)}</p>
      
      <textarea
      className={styles["note-item__body"]}
              onChange={(e) => handleChangeNoteData(e, id)}
              name="body"
              defaultValue={body}
              placeholder="Моя заметка..."
            ></textarea>
      
    </div>
  );
};

export default ShowItems;
